import { combineReducers } from 'redux';

import {
    REQUEST_ALO_CONNECTIONS,
    RECEIVE_ALO_CONNECTIONS,
    FAILURE_ALO_CONNECTIONS,
    REQUEST_ALO_DELETE_CONNECTION,
    SUCCESS_ALO_DELETE_CONNECTION,
    FAILURE_ALO_DELETE_CONNECTION,
    REQUEST_ALO_DELETE_ACCOUNT,
    SUCCESS_ALO_DELETE_ACCOUNT,
    FAILURE_ALO_DELETE_ACCOUNT,
    REQUEST_ALO_REACTIVATE_ACCOUNT,
    SUCCESS_ALO_REACTIVATE_ACCOUNT,
    FAILURE_ALO_REACTIVATE_ACCOUNT
} from './constants';

const connections = (state = [], action) => {
    switch (action.type) {
        case RECEIVE_ALO_CONNECTIONS:
            return action.response.payload;
        case REQUEST_ALO_CONNECTIONS:
        case FAILURE_ALO_CONNECTIONS:
            return [];
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_ALO_CONNECTIONS:
            return true;
        case FAILURE_ALO_CONNECTIONS:
        case RECEIVE_ALO_CONNECTIONS:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_ALO_CONNECTIONS:
            return action.response.message;
        case REQUEST_ALO_CONNECTIONS:
        case RECEIVE_ALO_CONNECTIONS:
            return '';
        default:
            return state;
    }
};

const deletingAccountConnection = (state = false, action) => {
    switch (action.type) {
        case REQUEST_ALO_DELETE_CONNECTION:
        case REQUEST_ALO_DELETE_ACCOUNT:
            return true;
        case FAILURE_ALO_DELETE_CONNECTION:
        case FAILURE_ALO_DELETE_ACCOUNT:
        case SUCCESS_ALO_DELETE_CONNECTION:
        case SUCCESS_ALO_DELETE_ACCOUNT:
            return false;
        default:
            return state;
    }
};

const reactivatingAccount = (state = false, action) => {
    switch (action.type) {
        case REQUEST_ALO_REACTIVATE_ACCOUNT:
            return true;
        case FAILURE_ALO_REACTIVATE_ACCOUNT:
        case SUCCESS_ALO_REACTIVATE_ACCOUNT:
            return false;
        default:
            return state;
    }
};

export default combineReducers({
    connections,
    fetching,
    error,
    deletingAccountConnection,
    reactivatingAccount
});



// WEBPACK FOOTER //
// ./src/services/account/alo/reducer.js